import { makeAutoObservable } from "mobx";
import { doGET } from "../../util/HttpUtil";


class AddressField {

    cities = [];

    constructor() {
        makeAutoObservable(this);
    }

    fetch = async function () {
        try {
            const response = await doGET("/api/o/city/grid?country=India&rows=-1");
            if (response.status === 200) {
                this.cities = response?.data?.rows;
            } else {
                this.error = response.data;
            }
        } catch (err) {
            this.error = err;
        }
    };
}

const AutoFillService = new AddressField();
export default AutoFillService;